import { useState, useEffect } from 'react'
import { useAtom } from 'jotai'

import {
  hidden,
} from './style'
import { AfterCallFinish } from 'components/AfterCallFinish'
import { CallDisplay } from 'components/CallDisplay'
import { InquiryButton } from 'components/InquiryButton'
import { SettingModal } from 'components/SettingModal'
import { Reconnect } from 'components/Reconnect'
import { SystemError } from 'components/SystemError'
import { Timeout } from 'components/Timeout'
import { TransitionRequest } from 'components/TransitionRequest'
import { useSession } from "hooks/useSession"
import { useUserInfo } from "hooks/useUserInfo"
import { getLocalStorage, clearLocalStorage } from 'utils/localStorage'
import {
  siteCodeAtom,
  sessionIdAtom,
  wsStatusAtom,
  finishModalIsOpenAtom,
  anotherTabCallingAtom,
  timeoutModalIsOpenAtom,
  systemErrorModalIsOpenAtom,
  recallModalIsOpenAtom,
  recallCountAtom
} from 'states'
import { AppPropsTypes } from "types"

function App(props: AppPropsTypes) {
  const [, setSiteCode] = useAtom(siteCodeAtom)
  const [, setSessionId] = useAtom(sessionIdAtom)
  const { sessionData, sessionErrorStatus } = useSession(props.siteCode, !!(sessionStorage.getItem('sessionId')))
  if (sessionData?.session_id) sessionStorage.setItem('sessionId', sessionData?.session_id)
  const sessionId = sessionStorage.getItem('sessionId') || sessionData?.session_id
  const { userInfoData, userInfoErrorStatus } = useUserInfo(sessionId)
  const [isOpen, setOpen] = useState<Boolean>(false)
  const [isHidden, setIsHidden] = useState<Boolean>(false)
  const [wsStatus, setWsStatus] = useAtom(wsStatusAtom)
  const [anotherTabCalling] = useAtom(anotherTabCallingAtom)
  const [finishModalIsOpen, setFinishModalIsOpen] = useAtom(finishModalIsOpenAtom)
  const [isOpenTimeoutModal, setIsOpenTimeoutModal] = useAtom(timeoutModalIsOpenAtom)
  const [isOpenSystemErrorModal, setIsOpenSystemErrorModal] = useAtom(systemErrorModalIsOpenAtom)
  const [isOpenRecallModal, setIsOpenRecallModal] = useAtom(recallModalIsOpenAtom)
  const [, setRecallCount] = useAtom(recallCountAtom)
  setSiteCode(props.siteCode)
  setSessionId(sessionId)

  // iPhoneのsafariでブラウザバックした時の対策
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      // bfcache発動時の処理
      window.location.reload();
    }
  });

  // エラーが出たらボタンを閉じる
  useEffect(() => {
    if (isOpenTimeoutModal || isOpenSystemErrorModal) setOpen(false)
  }, [isOpenTimeoutModal, isOpenSystemErrorModal])

  useEffect(() => {
    // 別タブ遷移の場合、peerIDを確認している間非表示にする
    if (getLocalStorage('operatorPeerId') && !anotherTabCalling) setIsHidden(true)
    if (anotherTabCalling) setIsHidden(false)
    // closeされた時、もしくは別タブ遷移の場合画面を閉じる
    if ((wsStatus === "closed") || anotherTabCalling) {
      // setIsHidden(false)
      setOpen(false)
    }
    // 自動的に画面を開く
    if (
      // 同タブ遷移の場合
      (getLocalStorage('operatorPeerId') && !anotherTabCalling) ||
      // 通話中に遷移した別タブ上で、通話終了後に開けるように
      (!getLocalStorage('operatorPeerId') && anotherTabCalling)
    ) {
      setOpen(true)
    }
    if (wsStatus !== "closed") setIsHidden(false)
  }, [anotherTabCalling, wsStatus])

  // エラーがなく表示設定がfalseならウィジェット非表示
  if (userInfoData?.display === 0 && !userInfoErrorStatus) {
    clearLocalStorage()
    return <></>
  }
  // 表示設定取得中はウィジェット非表示
  if (!userInfoData?.display && !userInfoErrorStatus) return <></>

  // エラーがあったらウィジェット非表示
  if (sessionErrorStatus || userInfoErrorStatus) {
    clearLocalStorage()
    return <></>
  }

  return (
    <div className={isHidden ? hidden : ''}>
      <TransitionRequest />
      {!isOpen && !sessionErrorStatus && (
        <InquiryButton
          onClick={() => {
            getLocalStorage('operatorPeerId') && anotherTabCalling ?
              alert('別タブで通話中です')
              :
              setOpen(true)
          }}
        />
      )}
      {isOpen && !sessionErrorStatus && <CallDisplay onClose={() => setOpen(false)}/>}
      <SettingModal
        isOpen={finishModalIsOpen}
        onRequestClose={() => setFinishModalIsOpen(false)}
        label="finish"
      >
        <AfterCallFinish />
      </SettingModal>
      <SettingModal
        isOpen={isOpenTimeoutModal}
        onRequestClose={() => setIsOpenTimeoutModal(false)}
        label="timeout"
      >
        <Timeout />
      </SettingModal>
      <SettingModal
        isOpen={isOpenSystemErrorModal}
        onRequestClose={() => setIsOpenSystemErrorModal(false)}
        label="systemerror"
      >
        <SystemError />
      </SettingModal>
      <SettingModal
        isOpen={isOpenRecallModal}
        onRequestClose={() => {
          setIsOpenRecallModal(false)
          setRecallCount(0)
          setWsStatus("closed")
        }}
        label="reconnect"
      >
        <Reconnect />
      </SettingModal>
    </div>
  )
}

export default App;
